const darkTheme = {
  bg: "#2B384C",
  border: "#A9ABBC",
  color: "#F0F2EF",
  display: "#6e6867",
  buttonShadow: "#92979F",
  buttonBorder: "#7D5E5A",
  buttonText: "#F0F2EF",
  buttonBg1: "#8E7971",
  buttonBg2: "#967e7b",
  buttonTextShadow: "#2b665e"
};

const lightTheme = {
  bg: "#d9d9d9",
  border: "#1b454f",
  color: "#d6e8b0",
  display: "#44656b",
  buttonShadow: "#91b8b3",
  buttonBorder: "#566963",
  buttonText: "#dce3ca",
  buttonBg1: "#768d87",
  buttonBg2: "#6c7c7c",
  buttonTextShadow: "#2b665e"
};

export { darkTheme, lightTheme };
